/* VialArt / VialCase — sample-name popup on design click.
   If a customer clicks a gallery design BEFORE typing what they're labeling,
   ask for the sample/compound name in a modal; on submit, fill the builder's
   name field (firing its input pipeline: va-name sync, ✓ chip, dose reveal)
   and then complete their original design selection.
   Standard mode only (skips the Upload Your Own tile and upload/commercial
   flows, mirroring va-flow2's visibility check on #va-pep-other).
   Identical file ships to BOTH themes. */
(function () {
  var PLACEHOLDER = 'Your Compound';
  var open = false;

  function nameMissing() {
    var oth = document.getElementById('va-pep-other');
    var nm = document.getElementById('va-name');
    var ov = oth && (oth.value || '').trim();
    var nv = nm && (nm.value || '').trim();
    if (ov) return false;
    if (nv && nv !== PLACEHOLDER) return false;
    return true;
  }

  function ensureCss() {
    if (document.getElementById('va-sp-css')) return;
    var st = document.createElement('style');
    st.id = 'va-sp-css';
    st.textContent =
      '.va-sp-ovl{position:fixed;inset:0;z-index:100000;background:rgba(8,5,20,.72);display:flex;align-items:center;justify-content:center;padding:18px;}'
      + '.va-sp{width:100%;max-width:420px;background:linear-gradient(160deg,#1b1030,#231543);border:1px solid rgba(124,77,255,.55);border-radius:16px;'
      + 'padding:22px 20px;box-shadow:0 24px 70px rgba(0,0,0,.6);font-family:system-ui,-apple-system,sans-serif;color:#fff;position:relative;}'
      + '.va-sp h3{margin:0 0 6px;font-size:18px;font-weight:800;}'
      + '.va-sp p{margin:0 0 14px;font-size:13px;color:#b9aee0;line-height:1.4;}'
      + '.va-sp input{width:100%;box-sizing:border-box;font-size:16px;font-weight:700;color:#fff;background:#140e26;'
      + 'border:1.5px solid rgba(124,77,255,.5);border-radius:10px;padding:13px 14px;outline:none;}'
      + '.va-sp input:focus{border-color:#9b6dff;box-shadow:0 0 0 3px rgba(124,77,255,.25);}'
      + '.va-sp-err{min-height:16px;font-size:12px;font-weight:700;color:#fca5a5;margin:6px 0 2px;}'
      + '.va-sp-go{width:100%;margin-top:8px;background:linear-gradient(120deg,#6d3bff,#9b5cff);color:#fff;border:none;border-radius:11px;'
      + 'padding:14px;font-size:15px;font-weight:900;cursor:pointer;box-shadow:0 8px 22px rgba(124,77,255,.35);}'
      + '.va-sp-go:hover{filter:brightness(1.08);}'
      + '.va-sp-x{position:absolute;top:10px;right:12px;background:none;border:none;color:#8f83b8;font-size:22px;line-height:1;cursor:pointer;padding:4px;}'
      + '.va-sp-x:hover{color:#fff;}'
      + '@media(max-width:480px){.va-sp{padding:18px 15px;}}';
    document.head.appendChild(st);
  }

  function ask(onSubmit) {
    if (open) return;
    open = true;
    ensureCss();
    var prevFocus = document.activeElement;
    var ovl = document.createElement('div');
    ovl.className = 'va-sp-ovl';
    ovl.innerHTML =
      '<div class="va-sp" role="dialog" aria-modal="true" aria-labelledby="va-sp-t">'
      + '<button type="button" class="va-sp-x" aria-label="Close">&times;</button>'
      + '<h3 id="va-sp-t">&#9889; What sample are you labeling?</h3>'
      + '<p>Type the name you want printed on this label &mdash; then we’ll apply it to the design you picked.</p>'
      + '<input type="text" maxlength="22" placeholder="Type what you want on the label..." '
      + 'autocapitalize="words" autocorrect="off" autocomplete="off" spellcheck="false" aria-label="Sample name">'
      + '<div class="va-sp-err"></div>'
      + '<button type="button" class="va-sp-go">Continue with this design &#8594;</button>'
      + '</div>';
    document.body.appendChild(ovl);
    var inp = ovl.querySelector('input');
    var err = ovl.querySelector('.va-sp-err');
    function close() {
      open = false;
      ovl.remove();
      document.removeEventListener('keydown', onKey, true);
      try { if (prevFocus && prevFocus.focus) prevFocus.focus(); } catch (e) {}
    }
    function submit() {
      var v = (inp.value || '').trim();
      if (!v) { err.textContent = 'Please type a name first — e.g. "BPC-157" or "5 mL sample".'; inp.focus(); return; }
      close();
      onSubmit(v);
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); }
      else if (e.key === 'Enter' && e.target === inp) { e.preventDefault(); submit(); }
    }
    ovl.addEventListener('mousedown', function (e) { if (e.target === ovl) close(); });
    ovl.querySelector('.va-sp-x').addEventListener('click', close);
    ovl.querySelector('.va-sp-go').addEventListener('click', submit);
    document.addEventListener('keydown', onKey, true);
    setTimeout(function () { try { inp.focus(); } catch (e) {} }, 40);
  }

  function applyName(v) {
    // Set BOTH the step-1 quick-entry AND the personalize name field directly.
    // Relying only on the pep-other -> setName -> va-name listener chain left
    // va-name on its placeholder in some paths, so add-to-cart rejected it
    // ("add your compound / peptide name"). Setting va-name here is the fix.
    var oth = document.getElementById('va-pep-other');
    var nm = document.getElementById('va-name');
    if (oth) { oth.value = v; oth.dispatchEvent(new Event('input', { bubbles: true })); }
    if (nm) { nm.value = v; nm.dispatchEvent(new Event('input', { bubbles: true })); }
  }

  document.addEventListener('click', function (e) {
    try {
      if (open) return;
      var di = e.target && e.target.closest && e.target.closest('.va-di[data-k]');
      if (!di) return;
      if (di.classList.contains('va-di-upl')) return;                 // upload tile has its own flow
      if (di.getAttribute('data-k') === 'custom_upload') return;
      var oth = document.getElementById('va-pep-other');
      if (!oth || oth.offsetParent === null) return;                  // upload/commercial modes: skip
      if (!nameMissing()) return;                                     // name present -> native flow
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      ask(function (v) {
        applyName(v);
        // complete the customer's original intent: select the design they tapped
        setTimeout(function () {
          try { di.click(); } catch (err) {}
        }, 60);
      });
    } catch (err) {}
  }, true);
})();
